export class Storage {

  public static get<T>(key: string, defaultValue: T = null): T {
    try {
      let str = localStorage.getItem(key);

      if (str == null) return defaultValue;

      return JSON.parse(str);
    }
    catch (e) {
      return defaultValue;
    }
  }

  public static has(key: string): boolean {
    return localStorage.hasOwnProperty(key);
  }

  public static set<T>(key: string, value: T): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    }
    catch (e) {
      return false;
    }
  }
}
